// extracted by mini-css-extract-plugin
module.exports = {"calendar-day":"Day_calendar-day__1S5rh","todolist":"Day_todolist__5QRB-","log":"Day_log__2UDVk"};